import React from 'react';

const AvailableEventsPageSkeleton: React.FC = () => (
  <div className="flex flex-col gap-6 py-5 h-full min-h-screen">
    {/* Carousel skeleton */}
    <div className="w-full overflow-hidden rounded-2xl">
      <div className="w-full aspect-[1920/700] bg-neutral-200 dark:bg-neutral-700 animate-pulse rounded-2xl" />
    </div>

    {/* Lottie animation placeholder */}
    <div className="w-full h-10 bg-neutral-200 dark:bg-neutral-700 animate-pulse rounded-lg" />

    {/* Optional members block can appear here in real page; skipping for skeleton */}

    {/* "Próximos eventos" header skeleton */}
    <div className="flex flex-row items-center gap-4">
      <div className="h-8 w-56 bg-neutral-200 dark:bg-neutral-700 animate-pulse rounded-md" />
      <div className="w-10 h-10 bg-neutral-200 dark:bg-neutral-700 animate-pulse rounded-lg" />
    </div>

    {/* Event cards grid skeleton */}
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 mb-20 gap-6 items-center flex-wrap">
      {[...Array(6)].map((_, index) => (
        <div key={index} className="group flex flex-col items-center w-full h-full p-3 rounded-3xl landing-event-card-shadow bg-blur-lg bg-opacity-heavy gap-3">
          <div className="w-full relative rounded-2xl">
            <div className='overflow-hidden rounded-2xl'>
              <div className="w-full aspect-[1920/700] bg-neutral-200 dark:bg-neutral-700 animate-pulse" />
            </div>
          </div>
          <div className="flex flex-col items-center w-full gap-3 h-full">
            <div className="h-6 w-3/4 bg-neutral-200 dark:bg-neutral-700 animate-pulse rounded-md" />
            <div className="h-4 w-1/2 bg-neutral-200 dark:bg-neutral-700 animate-pulse rounded-md" />
            <div className="h-4 w-2/3 bg-neutral-200 dark:bg-neutral-700 animate-pulse rounded-md" />
            <div className='flex h-full items-end w-fit mb-3'>
              <div className="h-10 w-40 bg-neutral-200 dark:bg-neutral-700 animate-pulse rounded-md" />
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default AvailableEventsPageSkeleton;
